import defaultAttributes from '../defaultAttributes';
import type { IconNode } from '../types';

const AlignHorizontalJustifyEnd: IconNode = [
  'svg',
  defaultAttributes,
  [
    ['rect', { x: '2', y: '5', width: '6', height: '14', rx: '2' }],
    ['rect', { x: '12', y: '7', width: '6', height: '10', rx: '2' }],
    ['path', { d: 'M22 2v20' }],
  ],
];

export default AlignHorizontalJustifyEnd;
